import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdBanner from './AdBanner';

function Home() {
  return (
    <div className="container mt-5">
      <div className="text-center">
        <h1 className="mb-4">MBTI 성격유형 테스트</h1>
        <p className="lead mb-5">
          나의 성격유형을 알아보고 자신에 대해 더 잘 이해해 보세요!
          이 테스트는 약 5분 정도 소요됩니다.
        </p>
        <Link to="/test" className="btn btn-primary btn-lg">
          테스트 시작하기
        </Link>
      </div>
      
      {/* 광고 배너 영역 */}
      <div className="mt-5 text-center">
        <AdBanner adSlot="1234567890" format="horizontal" />
      </div>
    </div>
  );
}

export default Home;